import styled from '@emotion/styled';
import { Stack } from '@mui/material';

export const SocialProfileBlockWrapper = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  borderRadius: '10px',
  border: `1px solid ${theme.colors.border.subtle}`,
  backgroundColor: theme.colors.background.canvas,
}));

export const SocialProfileRow = styled(Stack)(({ theme }) => ({
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0px 16px',
  height: 46,
  borderBottom: `1px solid ${theme.colors.border.subtle}`,
}));

export const SocialProfileDialogRow = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  gap: '8px',
  padding: '8px',
  cursor: 'pointer',
  borderRadius: '6px',
  '&:hover': {
    backgroundColor: theme.colors.white[4],
  },
}));
